<template>
    <b-card header-tag="header" footer-tag="footer">
        <template #header>
            Logout
        </template>
        <b-card-text>
            <p>You have been logged out!</p>
        </b-card-text>
        <b-button variant="info" @click="$router.push({ name: 'Login'})">Return to Login</b-button>
    </b-card>
</template>

<script>
export default {
    name: 'Logout',
    mounted() {
        this.logout();
    },
    methods: {
        logout() {
            this.$http
                .get('/auth/logout')
                .then(response => {
                    console.log("Logged out");
                });
        }
    }
}
</script>

<style scoped>
    .card {
        margin: 100px auto;
        width: 400px;
    }
    .card-header {
        background-color: black;
        color: white;
        font-weight: bold;
        font-size: 1.3rem;
    }
    .card-login {
        background-color: #f7f7f7;
        color: #000;
    }
</style>